<template>
<div class="mCategory">
    <!-- <div class="ch-category">
        <div class="course">
            <div class="title tc-blue">课程分类</div>
            <div class="summary">
                <span class="box" v-for="(obj) in courseList" :key="obj.code" @click="gotoCourseListBySort(obj)">{{obj.name}}</span>
            </div>
        </div>
        <div class="hot">
            <div class="title tc-red">题库分类</div>
            <div class="summary">
                <span class="box" v-for="(obj) in hotList" :key="obj.code" @click="gotoCourseListByHot(obj)">{{obj.name}}</span>
            </div>
        </div>
    </div> -->
    <div class="sort">
        <div class="title">快速入口<div @click="toSearch()" class="more_text_box">更多 ></div></div>
        <div class="summary">
            <div class="box" :class="'bg-sort'+(index+1)" v-for="(obj,index) in categoryList" :key="index" >
                <div class="name" v-if="index !== 2" @click="gotoCourseListByCategory(obj)">{{obj.name}}</div>
                <div v-else class="name" @click="goToTest">基金考试</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getIndexCategory} from 'api/indexApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'mCategory',
    data() {
        return {
            courseList: [
                // {code: '01', name: '资本运营'},
                // {code: '02', name: '市值管理'},
                // {code: '03', name: '职业考试'},
                // {code: '04', name: '职场提升'},
                // {code: '05', name: '编程与开发'},
                // {code: '06', name: '产品与运营'},
                {code: '01', name: '资本运营'},
                {code: '02', name: '金融考证'},
                {code: '03', name: '财税'},
                {code: '04', name: '投资理财'},
                {code: '05', name: '商业管理'},
                {code: '06', name: '创业创新'}
            ],
            hotList: [
                // {code: '51', name: '会计从业资格'},
                // {code: '52', name: '注册会计师'},
                // {code: '53', name: '证劵从业资格'},
                // {code: '54', name: '人力资源'},
                // {code: '55', name: '期货从业资格'},
                // {code: '56', name: '证劵经纪人'},
                {code: '57', name: '基金从业'},
                {code: '55', name: '期货从业'},
                {code: '58', name: '管理会计CMA'},
                {code: '59', name: '注册会计CPA'},
                {code: '53', name: '证券从业'},
                {code: '60', name: '董秘考证'},
                {code: '61', name: '税务师'},
            ],
            categoryList: []
        }
    },
    mounted() {
        this.getCategoryList()
    },
    methods: {
        toSearch() {
            this.$router.push({name: 'MCategoryList'});
        },
        gotoCourseListBySort(obj) {
            this.setRefresh(true)
            this.$router.push({name: 'MSearchList', query: {catecode: obj.code,searchtype:1, key: ''}})
        },
        gotoCourseListByHot(obj) {
            this.setRefresh(true)
            this.$router.push({name: 'MSearchList', query: {catecode: obj.code,searchtype:2, key: ''}})
        },
        gotoCourseListByCategory(obj) {
            this.setRefresh(true)
            this.$router.push({name: 'MSearchList', query: {catecode: obj.code,searchtype:1, key: '', time: (new Date()).getTime()}})
        },
        goToTest() {
            this.$router.push({
                name: 'QuestionList',
                query: {
                    code: 'jjcy'
                }
            })
        },
        getCategoryList() {
            this.setLoading(true)
            getIndexCategory({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.categoryList = data.data.content
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.mCategory {
    .ch-category{
        background: $c-white;
        overflow: hidden;
        height: 1.5rem;
        box-sizing: border-box;
        padding: 0.12rem 0.32rem;
        display: flex;
        justify-content: space-between;
        .course,.hot{
            width: 3.35rem;
        }
        .hot{
            margin-left:0.16rem;
        }
        .title{
            font-size: 0.26rem;
            line-height: 0.4rem;
            font-weight: 600;
        }
        .summary{
            margin-top: 0.12rem;
            font-size: 0.22rem;
            color: $c-grey;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .box{
                margin-right: 0.08rem;
                margin-bottom: 0.12rem;
                line-height: 0.32rem;
            }
        }
    }
    .sort{
        background: $c-white;
        margin-top: 0.2rem;
        padding: 0.2rem 0.32rem;
        font-weight: 600;
        .title{
            font-size: 0.32rem;
            color: $c-black;
            font-weight: 600;
            display: flex;
            justify-content: space-between;
            .more_text_box{
                color: #999;
                font-size: 0.24rem;
                font-weight: normal;
            }
        }
        .summary{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .box{
                width: 2.1rem;
                height: 1.1rem;
                margin-top: 0.2rem;
                position: relative;
                .name{
                    position: absolute;
                    top: 0;
                    left:0;
                    right:0;
                    bottom:0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: $c-white;
                    font-size: 0.28rem;
                }
            }
        }
    }
}
</style>